"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactjs_crontab_1 = __importDefault(require("reactjs-crontab"));
const constants_1 = require("../../../assets/constants/constants");
const response_codes_1 = require("../../../assets/constants/response_codes");
const underline_1 = __importDefault(require("../../../components/underline"));
const booking_requests_1 = require("../../../dataSource/booking_requests");
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const detectDevice_1 = __importDefault(require("../../../utils/detectDevice"));
const logoutUser_1 = require("../../../utils/logoutUser");
const message_utils_1 = __importDefault(require("../../../utils/message_utils"));
const PerfilStyles_1 = require("../perfil/PerfilStyles");
const Card_1 = __importDefault(require("./components/card/Card"));
const NoReserves_1 = __importDefault(require("./components/noReservesAvaiable/NoReserves"));
const ReservesStyles_1 = require("./ReservesStyles");
const MOBILE_WIDTH = 992;
const Reserves = () => {
    const [reservesList, setReservesList] = (0, react_1.useState)([]);
    const { isMobile } = (0, detectDevice_1.default)(MOBILE_WIDTH);
    const history = (0, react_router_dom_1.useHistory)();
    const getHistoryBookings = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield (0, booking_requests_1.getMyBookings)();
        if (data.code === response_codes_1.BookingCodes.success) {
            setReservesList(data.bookings);
        }
        else if (data.code === response_codes_1.BookingCodes.UNAUTHORIZED) {
            (0, logoutUser_1.handleLogout)(history, RoutesPaths_1.routesPaths.login);
            message_utils_1.default.error({ message: 'Sessão Expirada' });
        }
        else {
            message_utils_1.default.error({ message: 'Aconteceu algum erro!' });
        }
    }), [history]);
    (0, react_1.useEffect)(() => {
        getHistoryBookings();
    }, [getHistoryBookings]);
    const getBookingsInstructions = (0, react_1.useCallback)(() => {
        getHistoryBookings();
    }, [getHistoryBookings]);
    const tasks = react_1.default.useMemo(() => [
        {
            fn: getBookingsInstructions,
            config: constants_1.BOOKING_TIME_CHECKIN_LIMIT,
        },
    ], [getBookingsInstructions]);
    const reloadBookings = () => {
        getHistoryBookings();
    };
    return (react_1.default.createElement(ReservesStyles_1.ReservesContainer, null,
        react_1.default.createElement(reactjs_crontab_1.default, { tasks: tasks, timeZone: constants_1.TIME_ZONE_DEFAULT, dashboard: {
                hidden: true,
                route: '/',
            } }),
        !isMobile && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(PerfilStyles_1.Text, { size: 48 }, "Hospedagens"),
            react_1.default.createElement(underline_1.default, { style: { marginBottom: '30px' } }))),
        reservesList.map((reserve) => (react_1.default.createElement(Card_1.default, { reserve: reserve, key: reserve.bookingId, reloadBookings: reloadBookings }))),
        !reservesList.length && react_1.default.createElement(NoReserves_1.default, null)));
};
exports.default = Reserves;
